import moment from 'moment';

const currentYear = new Date().getFullYear();
const cabareis = `Listing information is being provided by the BAREIS Inc., MLS. IDX information
  is provided exclusively for consumers' personal, non-commercial use and may not
  be used for any purpose other than to identify prospective properties consumers
  may be interested in purchasing.`;
const cacrmls = `Display of MLS data is usually deemed reliable but is NOT guaranteed accurate by
  the MLS. Buyers are responsible for verifying the accuracy of all information and should
  investigate the data themselves or retain appropriate professionals. Unless otherwise
  specifed in writing, Broker/Agent has not and will not verify any information obtained
  from other sources. Copyright &copy;${currentYear} by the following Association of REALTORS - North San
  Luis Obispo County, Scenic Coast, San Luis Obispo, Pismo Coast, Santa Maria, Santa Ynez Valley,
  Lompoc Valley. All rights reserved. 
  Copyright &copy;${currentYear} Rapattoni Corporation. All rights reserved.`;
const careil_r = `&copy; ${currentYear} MLSListings Inc. All rights reserved.<br />
  The data relating to real estate for sale on this website comes in part from
  the Internet Data Exchange program of the MLSListings&#8482; MLS system.<br />
  This data is updated every 12 hours. Some properties appearing for sale on this
  website may subsequently have sold and may no longer be available.<br />`;
const carets = `Based on information from the Association of REALTORS®/Multiple Listing as
  of ${moment().subtract(1, 'days').format('MMMM Do YYYY')}. All data, including all
  measurements and calculations of area, is obtained from various sources and
  has not been, and will not be, verified by broker or MLS. All information should
  be independently reviewed and verified for accuracy. Properties may or may
  not be listed by the office/agent presenting the information.`;
const casbaor = `Display of MLS data is usually deemed reliable but is NOT guaranteed accurate by the MLS. Buyers are 
  responsible for verifying the accuracy of all information and should investigate the data themselves or retain 
  appropriate professionals. Information from sources other than the Listing Agent may have been included in the MLS 
  data. Unless otherwise specified in writing, Broker/Agent has not and will not verify any information obtained from 
  other sources. The Broker/Agent providing the information contained herein may or may not have been the Listing 
  and/or Selling Agent.<br />
  Santa Barbara Association of REALTORS®<br />`;
const casfar = `&copy; ${currentYear} San Francisco
  Association of Realtors. All rights reserved. Listings on this page identified
  as belonging to another listing firm are based upon data obtained from the SFAR
  MLS, which data is copyrighted by the San Francisco Association of
  REALTORS&copy;, but is not warranted. IDX information is provided exclusively
  for consumers' personal, non-commercial use and may not be used for any purpose
  other than to identify prospective properties consumers may be interested in
  purchasing. Listing Broker has attempted to offer accurate data, but buyers are
  advised to confirm all data provided.`;
const ctcmlsgf = `CMLS © ${currentYear} Greater Fairfield County CMLS, Inc. All rights reserved.<br/>
  All information deemed reliable but not guaranteed.`;
const ctgreenw = `Information provided by the Greenwich Multiple Listing Service, Inc. © ${currentYear}.<br/>
  Any information relating to a property, regardless of source, including but not limited to square footage, lot sizes, 
  price, or status is deemed reliable but not guaranteed and should be personally verified through personal inspection 
  and/or with the appropriate professionals.`;
const flpbbor = `The data relating to real estate for sale on this website comes in part from a cooperative data exchange 
  program of Palm Beach Board of Realtors' Multiple Listing Service. Real estate listings held by brokerage firms other 
  than Sothebys International Realty are marked with the Listing broker's logo or name and detailed information about such 
  listings includes the name of the listing brokers. Data provided is deemed reliable but is not guaranteed.`;
const flrmls = `All listings featuring the BMLS logo are provided by BeachesMLS Inc. This information is not verified for 
  authenticity or accuracy and is not guaranteed. Copyright &copy;${currentYear} Beaches Multiple Listing Service, Inc. 
  Information is provided exclusively for consumers' personal, non-commercial use and may not be used for any 
  purpose other than to identify prospective properties consumers may be interested in purchasing.`;
const nmsfar = `&copy; ${currentYear}
  The data relating to real estate for sale in this web site comes in part from
  the Internet Data exchange ('IDX') program of SFAR MLS, Inc. Real estate
  listings held by brokers other than Sotheby's International Realty are marked with the IDX Logo.
  All data in this web site is deemed reliable but is not guaranteed. All
  information for consumers' personal non-commercial use and may not be used
  for any purpose other than to identify prospective properties consumers
  may be interested in purchasing.`;
const txhar = `Copyright &copy; ${currentYear}, Houston Realtors Information Service, Inc. All information provided is 
deemed reliable but is not guaranteed and should be independently verified.`;

export default [
  {
    image: '/img/idx/cci-mls-b.png',
    detailDisclaimer: `All data relating to real estate for sale on this page comes
      from the Broker Reciprocity (BR) of the Cape Cod & Islands Multiple Listing Service, Inc.
      Detailed information about real estate listings held by brokerage firms other than Sotheby's International
      Realty include the name of the listing broker. Neither the listing company nor Sotheby's International
      Realty shall be responsible for any typographical errors, misinformation, misprints and shall
      be held totally harmless. The Broker providing this data believes it to be correct, but advises
      interested parties to confirm any item before relying on it in a purchase decision.
      &copy; ${currentYear} Cape Cod & Islands Multiple Listing Service, Inc.`,
    link: null,
    mlsOrg: 'maccia',        
    searchDisclaimer: `The data relating to real estate for sale on this site comes from the Broker Reciprocity (BR) of
      the Cape Cod & Islands Multiple Listing Service, Inc.
      This data is updated daily. All properties are subject to prior sale, changes, or withdrawal. <br />
      &copy; {currentYear} Cape Cod & Islands Multiple Listing Service, Inc.`
  },
  {
    image: '/img/idx/the_mls.png',
    detailDisclaimer: carets,
    link: 'http://www.themls.com',
    mlsOrg: 'carets',
    searchDisclaimer: carets
  },
  {
    image: null,
    detailDisclaimer: cacrmls,
    link: null,
    mlsOrg: 'cacrmls',
    searchDisclaimer: cacrmls
  },
  {
    image: '/img/idx/mls.png',
    detailDisclaimer: careil_r,
    link: 'http://www.mlslistings.com',
    mlsOrg: 'careil_r',
    searchDisclaimer: careil_r
  },
  {
    image: null,
    detailDisclaimer: cabareis,
    link: null,
    mlsOrg: 'cabareis',
    searchDisclaimer: cabareis
  },
  {
    image: null,
    detailDisclaimer: casbaor,
    link: null,
    mlsOrg: 'casbaor',
    searchDisclaimer: casbaor,
  },
  {
    image: null,
    detailDisclaimer: casfar,
    link: null,
    mlsOrg: 'casfar',
    searchDisclaimer: casfar
  },
  {
    detailDisclaimer: ctcmlsgf,
    image: '/img/idx/ctcmlsgf.png',
    link: null,
    mlsOrg: 'ctcmlsgf',
    searchDisclaimer: ctcmlsgf,
  },
  {
    detailDisclaimer: ctgreenw,
    image: null,
    link: null,
    mlsOrg: 'ctgreenw',
    searchDisclaimer: ctgreenw,
  },
  {
    image: null,
    detailDisclaimer: flpbbor,
    link: null,
    mlsOrg: 'flpbbor',
    searchDisclaimer: null
  },
  {
    image: '/img/idx/flrmls-mls.png',
    detailDisclaimer: flrmls,
    link: null,
    mlsOrg: 'flrmls',
    searchDisclaimer: flrmls
  },
  {
    image: '/img/idx/idx_logo.png',
    detailDisclaimer: nmsfar,
    link: null,
    mlsOrg: 'nmsfar',
    searchDisclaimer: nmsfar
  },
  {
    image: null,
    detailDisclaimer: txhar,
    link: null,
    mlsOrg: 'txhar',
    searchDisclaimer: txhar
  }
];



// WEBPACK FOOTER //
// ./src/components/shared/idx/disclaimers.js